import { useRef, useState } from 'react';
import dayjs from 'dayjs';
import { useClickOutside } from '@/hooks/useClickOutside';
import styles from './CalendarDatePicker.module.scss';
import { Calendar } from '../Calendar/Calendar';

interface Props {
  value?: string;
  min?: string;
  max?: string;
  label: string;
  disabled?: boolean;
  className?: string;
  calendarClassName?: string;
  // eslint-disable-next-line no-unused-vars
  onSelect: (value: string) => void;
}

export function CalendarDatePicker({ value, min, max, label, disabled, className = '', calendarClassName = '', onSelect }: Props) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  useClickOutside(wrapperRef, open ? 1 : null, () => setOpen(false));

  const close = () => {
    setOpen(false);
    triggerRef.current?.focus();
  };

  const toggle = () => {
    setOpen(!open);
  };

  const displayValue = value ? dayjs(value).format('MM/DD/YYYY') : '';

  return (
    <div
      ref={wrapperRef}
      className={`${styles.picker} ${className}`}
      onKeyDown={(event) => {
        if (event.key === 'Escape' && open) {
          event.stopPropagation();
          close();
        }
      }}
    >
      <button ref={triggerRef} type="button" className={styles.trigger} aria-label={label} aria-haspopup="dialog" aria-expanded={open && !disabled} disabled={disabled} onClick={toggle}>
        <span>{displayValue}</span>
        <svg className={styles.icon} aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="5" width="18" height="16" rx="2" />
          <path d="M16 3v4M8 3v4M3 11h18" />
        </svg>
      </button>
      {open && !disabled && (
        <div role="dialog" aria-label={`${label} calendar`} className={`${styles.calendar} ${calendarClassName}`}>
          <Calendar value={value} min={min} max={max} onSelect={onSelect} close={close} />
        </div>
        //</div>
      )}
    </div>
  );
}
